




































import { Component, Vue } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'
import EditAiAppDialogBody from '@/apps/open/components/DialogBodys/ai/EditApp.vue'
import { getAIApps, updateAiApp, applyAiApp } from '@/apps/open/services/ai'
import { AIAppType } from '@/apps/open/types/ai'

interface AiAppInfo {
  app_id?: string | undefined,
  app_name: string,
  app_platform: string,
  description: string
}

@Component({
  components: {
    Button
  }
})
export default class AiApps extends Vue {
  apps: any = []
  activeIdx: number = -1

  tableHeaderStyle = {
    height: '48px',
    background: '#F3F3F3',
    'text-align': 'center',
    color: '#3C414B'
  }

  mounted () {
    this.initData()
    this.initEventListener()
  }

  beforeDestroy () {
    this.$eventBus.$clear('changeEnterprise', this.initData)
  }

  initEventListener () {
    this.$eventBus.$on('changeEnterprise', this.initData)
  }

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  async initData () {
    const params = {
      developer_id: `${this.curEnterprise.developer_id}`
    }
    const res = await getAIApps(params)
    if (res.status === 200 && res.data.data) {
      this.apps = res.data.data
    } else {
      this.apps = []
    }
  }

  get developerInfo () {
    return this.$store.getters['User/userInfo'].developer
  }

  tableRowStyle (item: any) {
    const index = item.columnIndex
    if (index === 4) {
      return {
        'text-align': 'center'
      }
    }
  }

  jumpAdmin (app_name: string) {
    this.$router.push({ name: 'ai-admin', params: { app_name } })
  }

  showEditAppDialog (appInfo: any, index: number) {
    const isEdit: boolean = !!appInfo
    if (isEdit) this.activeIdx = index
    this.$dialog.show({
      title: isEdit ? '编辑应用' : '申请应用',
      body: EditAiAppDialogBody,
      bodyProps: {
        data: appInfo,
        submit: this.apply
      },
      buttons: [
        { text: '取消' },
        { text: '确定', type: 'primary', event: 'onOk' }
      ]
    })
  }

  get isPassed () {
    return this.$store.getters['User/isPassedDeveloper']
  }

  get hasApps () {
    return this.apps && this.apps.length > 0
  }

  async apply ({ app_id, app_name, description, app_platform }: AiAppInfo) {
    try {
      if (app_id) {
        const params = {
          api_key: app_id,
          apiname: app_name,
          apiintro: description
        }
        const res = await updateAiApp(params)
        if (res.data.code === 1) {
          this.$message('申请已提交，请您耐心等待')
          this.initData()
        } else {
          throw new Error(res.data.msg)
        }
      } else {
        const params = {
          developer_id: `${this.curEnterprise.developer_id}`,
          apiname: app_name,
          apiscope: 'nlp_helper_gen nlp_auto_gen nlp_proof',
          apiorg: this.developerInfo.developer_name,
          apiplatform: app_platform,
          email: this.developerInfo.email,
          apiintro: description
        }
        const res = await applyAiApp(params)
        if (res.data.code === 1) {
          this.$message('申请已提交，请您耐心等待')
          this.initData()
        } else {
          throw new Error(res.data.msg)
        }
      }
    } catch (error) {
      this.$message.error(error.message)
    } finally {
      this.$dialog.close()
    }
  }
}
